import { render } from "./HelpVideo.vue?vue&type=template&id=613d710a&scoped=true"
import script from "./HelpVideo.vue?vue&type=script&lang=js"
export * from "./HelpVideo.vue?vue&type=script&lang=js"

import "./HelpVideo.vue?vue&type=style&index=0&id=613d710a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-613d710a"]])

export default __exports__